import styled from 'styled-components'

import { fontSize } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: linear-gradient(225deg, #fffdee 100%, #fef7e2);
  border-radius: 1.6rem;
  padding: 8.8rem 4.8rem 5.6rem 4.8rem;

  ${media.desktop} {
    width: 63.5rem;
  }

  svg {
    margin-bottom: 4.8rem;
  }

  h3 {
    font-size: ${fontSize.LARGE_XXXL};
    line-height: 1;
    margin: 0 0 1.6rem 0;
  }

  button {
    margin-top: 4.8rem;
  }
`
